import { Modal } from '@systemeio/ui'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { managementSelectors, useTypedSelector } from '../../../store'
import * as managementActions from '../../../store/management/actions'
import PopupLibraryContent from './PopupLibraryContent'
import { useEffect, useState } from 'react'

function PopupLibrary() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { entityId, position } = useTypedSelector(({ management }) =>
    managementSelectors.getInsertToForPopupLibrary(management),
  )

  useEffect(() => {
    if (entityId) {
      setIsModalOpen(true)
    }
  }, [entityId])

  return (
    <Modal
      title={t('core.popup_library.title')}
      opened={isModalOpen}
      afterLeave={() => dispatch(managementActions.setInsertToForPopupLibrary(null))}
      onClose={() => setIsModalOpen(false)}
    >
      {entityId && (
        <PopupLibraryContent
          parentId={entityId}
          position={position}
          onAdd={() => setIsModalOpen(false)}
        />
      )}
    </Modal>
  )
}

export default PopupLibrary
